import React, { useCallback, useEffect, useMemo, useState } from 'react'


import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import './ViewReimbursements.scss';
import axios from 'axios';
import { useAuth } from '../../../AuthProvider';
import { Button } from '@aws-amplify/ui-react';
import { Flex, Input, Table } from 'antd';
import { render } from '@testing-library/react';
import { v4 as uuidv4 } from 'uuid';
import { Tabs } from 'antd';
import ViewMultiReimbursements from '../../multi/ViewMultiReimbursements';
import { Visibility } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import { baseUrl_SPB } from '../../../BaseUrl';
import EditInvoiceCard from '../../card/EditInvoiceCard';
import FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { deleteReimbursement } from '../../../services/ReimbursementService';
import { Menu, MenuItem } from '@mui/material';
import ViewReimbursementActionMenu from '../../menu/ViewReimbursementActionMenu';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SideDrawer from '../../drawer/SideDrawer';
import ExpenseItemActionMenu from '../../menu/ExpenseItemActionMenu';

export default function ViewReimbursements(props) {
  const userContext = useAuth();
  const [reimbursements, setReimbursements] = React.useState([]);
  const [reimbursementsApproved, setReimbursementsApproved] = React.useState([]);
  const [reimbursementsRejected, setReimbursementsRejected] = React.useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [showEditDialog, setShowEditDialog] = React.useState(false);
  const [selectedRecordToProcess, setSelectedRecordToProcess] = React.useState(null);
  const [searchTermPending, setSearchTermPending] = useState('');
  const [searchTermApproved, setSearchTermApproved] = useState('');
  const [searchTermRejected, setSearchTermRejected] = useState('');
  const [open, setOpen] = React.useState(false);
  const start = () => {
    setLoading(true);
    // ajax request after empty completing
    setTimeout(() => {
      setSelectedRowKeys([]);
      setLoading(false);
    }, 1000);
  };
  const actionLabel = props.my === "" ? 'Action' : '';
  const onEdit = (record) => {
    console.log(record);
    console.log("AT PLAY");
    setShowEditDialog(true);
    setSelectedRecordToProcess(record)
  }

  const onDelete = (record) => {
    setSelectedRecordToProcess(record);
    if (record.status === 'pending') {

      let index = reimbursements.findIndex((item) => item.reimbursementId === record.reimbursementId);
      reimbursements.splice(index, 1);
      setReimbursements(reimbursements);
    } else if (record.status === 'approved') {
      let index = reimbursementsApproved.findIndex((item) => item.reimbursementId === record.reimbursementId);
      reimbursementsApproved.splice(index, 1);
      setReimbursementsApproved(reimbursementsApproved);
    } else if (record.status === 'rejected') {
      let index = reimbursementsRejected.findIndex((item) => item.reimbursementId === record.reimbursementId);
      reimbursementsRejected.splice(index, 1);
      setReimbursementsRejected(reimbursementsRejected);
    }
    deleteReimbursement(userContext.token, record.reimbursementId);
  }


  const onLoad = () => {
    console.log("insie view reimbursement effect");
    console.log(userContext.token);
    let url='';
    if(props.filterCategory==='EXPENSE'){
      url = `${baseUrl_SPB}/api/v1/reimburse/retrieveexpenses?companyId=${userContext.additionalUserInfo.companyId}`;
    } else {
      url = `${baseUrl_SPB}/api/v1/reimburse/retrievereimbursements/${props.my}`;
    }
    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userContext.token
      }
    })
      .then(response => {

        let modifiedDatawithKey = response.data.map((responseItem) => {
          responseItem.key = uuidv4();
          return responseItem;
        });


        setReimbursements(modifiedDatawithKey);

        return response;
      })
      .catch(error => {
        console.error('Error fetching user details and role:', error);
      });
     if(props.filterCategory==='EXPENSE'){
      url = `${baseUrl_SPB}/api/v1/reimburse/retrieveexpenses/approved?companyId=${userContext.additionalUserInfo.companyId}`;
    } else {
      url = `${baseUrl_SPB}/api/v1/reimburse/retrievereimbursements/approved/${props.my}`;
    }
    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userContext.token
      }
    })
      .then(response => {

        let modifiedDatawithKey = response.data.map((responseItem) => {
          responseItem.key = uuidv4();
          return responseItem;
        });


        setReimbursementsApproved(modifiedDatawithKey);
        return response;
      })
      .catch(error => {
        console.error('Error fetching user details and role:', error);
      });

    if(props.filterCategory==='EXPENSE'){
      url = `${baseUrl_SPB}/api/v1/reimburse/retrieveexpenses/rejected?companyId=${userContext.additionalUserInfo.companyId}`;
    } else {
      url = `${baseUrl_SPB}/api/v1/reimburse/retrievereimbursements/rejected/${props.my}`;
    }
    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userContext.token
      }
    })
      .then(response => {

        let modifiedDatawithKey = response.data.map((responseItem) => {
          responseItem.key = uuidv4();
          return responseItem;
        });


        setReimbursementsRejected(modifiedDatawithKey);
        setLoading(false);
        return response;
      })
      .catch(error => {
        setLoading(false);
        console.error('Error fetching user details and role:', error);
      });
  }

  const columns = [

    {
      title: 'Date created',
      dataIndex: 'createdDate',
      width: 120,

    },
    {
      title: props.filterCategory === 'EXPENSE' ? 'Supplier Name' : 'Name',
      dataIndex: 'claimantFullName',
      width: 150,
      render: (text, record) => {
        // Show supplierName for Bills/Expense (category EXPENSE), else claimantFullName
        if (props.filterCategory === 'EXPENSE' && record.supplierName) {
          return record.supplierName;
        }
        return record.claimantFullName;
      }
    },
    {
      title: 'Amount',
      dataIndex: 'claimedAmount',
      render: (text, record) => {
        if (record.claimedAmount) {
          return record.claimedAmount
        } else {
          if (record.reviewAttachmentDataArray && record.reviewAttachmentDataArray.length > 1) {
            let total = record.reviewAttachmentDataArray.reduce((acc, obj) => acc + parseInt(obj.claimedAmount), 0)
            let inditems = record.reviewAttachmentDataArray.map((item) => {
              return parseInt(item.claimedAmount) + ",";
            })
            return <div key={record.key+'amount-item'}><br />Total:{total} ({inditems})</div>

          }

        }

      },
      width: 80,
    },

    {
      title: 'Status',
      dataIndex: 'status',
      render: (text, record) => {
        return (
          <div key={record.key+'status-item'}>
            {record.status} {record.subStatus ? `- AP - (${record.subStatus})` : ''}
          </div>
        )
      },
      width: 80,
    },
    
    /*{
      title: 'Invoice',
      dataIndex: 's3ConnectionUrl',
      render: (text, record) => {
        if (record.s3ConnectionUrl) {
          return (
            <a key={record.key+'s3-con-url'} href={record.s3ConnectionUrl} target="">View</a>
          )
        } else {
          if (record.reviewAttachmentDataArray && record.reviewAttachmentDataArray.length > 1) {
            return record.reviewAttachmentDataArray.map((item) => {
              return <div key={record.key+'s3-con-url-wrapper'}><a key={record.key+'s3-con-url'} href={item.s3ConnectionUrl} target="">View</a><br /></div>
            })
          }

        }

      },
      
      width: 80,
    },
    {
      title: 'Invoice date',
      dataIndex: 'invoiceDate',
      width: 100,
    },*/
    {
      title: 'Reference',
      dataIndex: 'transactionReference',
      width: 100,

    },
    {
      title: 'Additional Info',
      dataIndex: 'additionalInfo',
      width: 105,

    },


    {
      title: actionLabel,
      dataIndex: '',
      render: (text, record) => {
        let key = record.key;
        delete record.key;
        return (
          <div key={record.key+'action-labels'} >
            <SideDrawer key={key + "side-drawer"} {...record} onApprove={onApprove} onLoad={onLoad} onEdit={onEdit} />
            {props.my === "" && (record.claimantManagerId===userContext.additionalUserInfo.reportingManagerId || userContext.role === 'ROLE_SADMIN' || userContext.role==='ROLE_CMANAGER')?
            <ExpenseItemActionMenu key={key + "action-menu"} my={props.my} record={record} onEdit={onEdit} onDelete={onDelete} onApprove={onApprove} onReject={onReject} onPay={onPay}/>
            :''}
          </div>
          
        )
      },
      width: 150,
    },
    {
      title: '',
      dataIndex: '',
    }

  ];


  const onExport = () => {
    console.log('selectedRowKeys: ', selectedRowKeys);
    const selectedRecords = reimbursementsApproved.filter((record) => {
      if (selectedRowKeys.includes(record.key)) {
        return record;
      }
    });
    exportExcel(selectedRecords, 'approved_reimbursements');
  }

  const exportExcel = (excelData, fileName) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  }
  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  useEffect(() => {
    setLoading(true);
    onLoad();
    setLoading(false);
  }, [userContext.token, props.my, props.recordsReloadKey]);

  const onProgressAPStatus = (id) => {
    console.log('s');
  }
  const onApprove = (id, currentStatus) => {
    let stq = currentStatus ? `&currentStatus=${currentStatus}` : '';
    axios.get(`${baseUrl_SPB}/api/v1/reimburse/approve?reimbursementId=${id}${stq}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userContext.token
      }
    })
      .then(response => {

        let modifiedDatawithKey = response.data.map((responseItem) => {
          responseItem.key = uuidv4();
          return responseItem;
        });


        setReimbursements(modifiedDatawithKey);

        return response;
      })
      .catch(error => {
        console.error('Error fetching user details and role:', error);
      });

    axios.get(`${baseUrl_SPB}/api/v1/reimburse/retrievereimbursements/approved/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userContext.token
      }
    })
      .then(response => {

        let modifiedDatawithKey = response.data.map((responseItem) => {
          responseItem.key = uuidv4();
          return responseItem;
        });


        setReimbursementsApproved(modifiedDatawithKey);
        return response;
      })
      .catch(error => {
        console.error('Error fetching user details and role:', error);
      });

  }


  const onReject = (id) => {

    axios.get(`${baseUrl_SPB}/api/v1/reimburse/reject?reimbursementId=${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userContext.token
      }
    })
      .then(response => {

        let modifiedDatawithKey = response.data.map((responseItem) => {
          responseItem.key = uuidv4();
          return responseItem;
        });


        setReimbursements(modifiedDatawithKey);

        return response;
      })
      .catch(error => {
        console.error('Error fetching user details and role:', error);
      });

    axios.get(`${baseUrl_SPB}/api/v1/reimburse/retrievereimbursements/rejected/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userContext.token
      }
    })
      .then(response => {

        let modifiedDatawithKey = response.data.map((responseItem) => {
          responseItem.key = uuidv4();
          return responseItem;
        });


        setReimbursementsRejected(modifiedDatawithKey);
        return response;
      })
      .catch(error => {
        console.error('Error fetching user details and role:', error);
      });

  }

  const onPay = (id) => {
   

      const urlToGo=`https://go.zeptopayments.com/oauth/authorize?client_id=X8X7DAMvwlVx-1T1jmtKOOBp4a_sAAR-uYyHWzVDGPQ&current_account_id=8b97f466-eaac-4d88-a045-84514650c5a9&redirect_uri=https%3A%2F%2Fportal.effiez.com.au%2Fzauthc?id=${id}&response_type=code&scope=contacts+payments`;
      window.location.replace(urlToGo);
  
    
   }
  const handleSearchChange = (setSearchTerm) => (e) => {
    setSearchTerm(e.target.value);
  };

  const filterData = (data, searchTerm) => {
    return data.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  };

  // Helper to filter by transactionReference/category if provided
  const filterByCategory = (data) => {
    if (props.filterCategory && props.filterCategory !== "") {
      return data.filter(item => item.transactionReference === props.filterCategory);
    }
    return data;
  };

  const pendingTable = () => {
    const filteredReimbursements = filterData(filterByCategory(reimbursements), searchTermPending);

    return (<Flex gap="middle" vertical>
      <Input
        placeholder="quick filter e.g. Jon Do or test@test.com"
        value={searchTermPending}
        onChange={handleSearchChange(setSearchTermPending)}
        style={{ width: '70%' }}
      />
      <Flex align="center" gap="middle">

        {hasSelected ? `Selected ${selectedRowKeys.length} items` : null}
      </Flex>
      <Table rowSelection={rowSelection} columns={columns} dataSource={filteredReimbursements} scroll={{ x: 2000 }} />

    </Flex>)
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };


  const approvedTable = () => {
    const filteredReimbursementsApproved = filterData(filterByCategory(reimbursementsApproved), searchTermApproved);

    return (<Flex gap="middle" vertical>

      <ViewReimbursementActionMenu onExport={onExport} />

      <Input
        placeholder="quick filter e.g. Jon Do or test@test.com"
        value={searchTermPending}
        onChange={handleSearchChange(setSearchTermPending)}
        style={{ width: '70%' }}
      />
      <Flex align="center" gap="middle">

        {hasSelected ? `Selected ${selectedRowKeys.length} items` : null}
      </Flex>
      <Table rowSelection={rowSelection} columns={columns} dataSource={filteredReimbursementsApproved} scroll={{ x: 2000 }} />

    </Flex>)
  }

  const rejectedTable = () => {
    const filteredReimbursementsRejected = filterData(filterByCategory(reimbursementsRejected), searchTermRejected);

    return (<Flex gap="middle" vertical>
      <Flex align="center" gap="middle">

        {hasSelected ? `Selected ${selectedRowKeys.length} items` : null}
      </Flex>
      <Table rowSelection={rowSelection} columns={columns} dataSource={filteredReimbursementsRejected} scroll={{ x: 2000 }} />

    </Flex>)
  }
  const items = [
    {
      key: '1',
      label: 'Pending',
      children: pendingTable(),
    },
    {
      key: '2',
      label: 'Approved',
      children: approvedTable(),
    },
    {
      key: '3',
      label: 'Rejected',
      children: rejectedTable(),
    },
  ];
  return (
    <div>
      <Card className="reimbursements-card">
        <CardContent>
          <div className="headerText">{props.my ? "Expense/claim/reimbursement - mine" : "Expense/claim/reimbursement - others"}</div>
          <Tabs defaultActiveKey="1" items={items} />
          {loading ? <CircularProgress style={{ position: 'absolute', top: '500px', marginLeft: '450px' }} /> : ''}

        </CardContent>
      </Card>
      <EditInvoiceCard open={showEditDialog} onClose={() => setShowEditDialog(false)} record={selectedRecordToProcess} reimbursements={reimbursements} reimbursementsApproved={reimbursementsApproved} setReimbursements={setReimbursements} setReimbursementsApproved={setReimbursementsApproved} />
    </div>
  )
}

